import PropTypes from "prop-types"
import { capitalize, toFixed } from "humanize-plus"
import thumbsUp from "images/partners/feedback/thumbs-up.svg"
import thumbsDown from "images/partners/feedback/thumbs-down.svg"
import PlatformFeedbackPage from "partners/components/platform_feedback/platform_feedback_page"

const RatingsOverview = ({
  serviceModuleName,
  appletSlug,
  likes,
  dislikes,
  positiveRatingPercentage,
  negativeRatingPercentage,
  opinionCodes,
  suggestedAppletQueryParams,
  newAppletPath,
  profileUrl,
}) => (
  <section className="applet-rating-overview-section">
    <div className="overview-container">
      <div className="overview-header">
        <h1>User Feedback</h1>
        {appletSlug && <p>User feedback and ratings for this Applet</p>}
      </div>
      {suggestedAppletQueryParams && (
        <p>
          This Applet was published by someone else in the IFTTT ecosystem,{" "}
          <a
            href={`${newAppletPath}/${suggestedAppletQueryParams}`}
            data-turbolinks="false"
          >
            build it yourself
          </a>{" "}
          to expand its market potential and enable user feedback.
        </p>
      )}
      <div className="applet-feedback-rating expanded">
        <div className="thumbs-container">
          <div className="positive-ratings">
            <h3 className="rating-description">Thumbs up</h3>
            <div className="rating-container">
              <span
                className="thumbs up"
                dangerouslySetInnerHTML={{ __html: thumbsUp }}
              />
              <span className="thumb-count">{likes}</span>
            </div>
          </div>
          <div className="vertical-divider" />
          <div className="negative-ratings">
            <h3 className="rating-description">Thumbs down</h3>
            <div className="rating-container">
              <span
                className="thumbs down"
                dangerouslySetInnerHTML={{ __html: thumbsDown }}
              />
              <span className="thumb-count">{dislikes}</span>
            </div>
          </div>
        </div>
        <div className="rating-bar">
          <span
            className={`positive-rating-bar ${
              positiveRatingPercentage > 0 ? "" : " zero"
            }`}
            style={{ width: `${positiveRatingPercentage}%` }}
          >
            <span>
              {positiveRatingPercentage > 0
                ? `${toFixed(positiveRatingPercentage, 0)}%`
                : null}
            </span>
          </span>
          <span
            className={`negative-rating-bar ${
              negativeRatingPercentage > 0 ? "" : " zero"
            }`}
            style={{ width: `${negativeRatingPercentage}%` }}
          >
            <span>
              {negativeRatingPercentage > 0
                ? `${toFixed(negativeRatingPercentage, 0)}%`
                : null}
            </span>
          </span>
        </div>
      </div>
    </div>
    {Object.keys(opinionCodes).some(val => opinionCodes[val]) && (
      <div className="overview-container">
        <div className="overview-header">
          <h4>Thumbs down reasons</h4>
        </div>
        <div className="thumbs-down-reasons expanded">
          {Object.keys(opinionCodes)
            .sort((a, b) => {
              if (opinionCodes[b] > opinionCodes[a]) return 1
              else if (opinionCodes[a] > opinionCodes[b]) return -1
              return 0
            })
            .map(code => {
              const count = opinionCodes[code]
              const percent = (count / dislikes) * 100 || 0
              return (
                <div key={code} className="reason">
                  <span>
                    {capitalize(
                      (code === "unexpected"
                        ? "doesn't work as expected"
                        : code === "no_response"
                        ? "no reason given"
                        : code
                      ).replace("_", " ")
                    )}
                  </span>
                  <span className="outer-bar">
                    <span
                      className="inner-bar"
                      style={{ width: `${percent}%` }}
                    >
                      <span>{toFixed(percent, 0)}%</span>
                    </span>
                  </span>
                  <span className="count">{count}</span>
                </div>
              )
            })}
        </div>
      </div>
    )}
    {appletSlug && (
      <PlatformFeedbackPage
        contentType="applet"
        feedbackType="applet_feedback"
        appletId={appletSlug}
        channel={serviceModuleName}
        profileUrl={profileUrl}
      />
    )}
  </section>
)

RatingsOverview.propTypes = {
  likes: PropTypes.number,
  dislikes: PropTypes.number,
  positiveRatingPercentage: PropTypes.number,
  negativeRatingPercentage: PropTypes.number,
  opinionCodes: PropTypes.object,
  suggestedAppletQueryParams: PropTypes.string,
  newAppletPath: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
  serviceModuleName: PropTypes.string.isRequired,
  appletSlug: PropTypes.string,
}

export default RatingsOverview
